import { t } from 'i18next';
import { ReactElement, useState } from 'react';
import { Trans } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import CompassIcon from '../../../Shared/Icons/CompassIcon';
import NavSidebarSection from '../NavSidebarSection';
import { SidebarProps } from './SidebarProps';
import { useDispatch } from 'react-redux';
import { Thunk } from '../../../../dux/@types';
import { checkPermission } from '../../../../dux';
import { g as abilityGlossary } from '../../../../config/ability';
import GateTooltip, { GateTooltipFeature } from '../../../Shared/Tooltips/TooltipGate';

const ExploreSidebarSection = (props: SidebarProps): ReactElement => {
  const { onNavClick } = props;
  const dispatch = useDispatch();
  const [showTooltip, setShowTooltip] = useState(false);

  const canViewHearings = (): Thunk<boolean> => {
    return dispatch(
      checkPermission(abilityGlossary.VIEW, abilityGlossary.HEARINGS, true),
    );
  };

  const getCardBody = (): ReactElement => {
    return (
      <>
        <NavLink
          activeClassName="active-nav-link"
          onClick={onNavClick}
          to="/jurisdictions"
        >
          <h4 className="sub-item">Overview</h4>
        </NavLink>
        <NavLink
          activeClassName="active-nav-link"
          id="universal-hearings-link"
          onClick={onNavClick}
          to={canViewHearings() ? '/hearings' : '/'}
        >
          <h4 className="sub-item">Hearings</h4>
        </NavLink>
        {!canViewHearings() && (
          <GateTooltip
            accountType="pro"
            anchorId="universal-hearings-link"
            customContent={
              <Trans
                components={{
                  hearingsLink: <a href={t('urls.hearings')} target="_blank" />,
                  gate: <p className="tooltip-header" />,
                }}
                i18nKey="featureGating.tooltipText.newHearingsPage"
              />
            }
            featureName={GateTooltipFeature.HearingsPage}
            isOpen={showTooltip}
            place="bottom"
            setIsOpen={setShowTooltip}
          />
        )}
      </>
    );
  };

  return (
    <NavSidebarSection
      cardBody={getCardBody()}
      customGateTooltipContent={
        <Trans
          components={{
            exploreLink: <a href={t('urls.legislatorDetails')} target="_blank" />,
            gate: <p className="tooltip-header" />,
          }}
          i18nKey="featureGating.tooltipText.exploreSidebar"
          key="featureGating.tooltipText.exploreSidebar"
        />
      }
      eventKey="EXPLORE"
      header="Explore"
      icon={<CompassIcon />}
    />
  );
};

export default ExploreSidebarSection;
